import React from "react";

export type TicketFiltersState = {
  siteId: number | "all";
  status: string | "all";
  severity: number | "all";
  search: string;
};

type Option = { id: number; name: string };

type Props = {
  sites: Option[];
  value: TicketFiltersState;
  onChange: (next: TicketFiltersState) => void;
};

const statuses = ["OPEN", "IN_PROGRESS", "RESOLVED", "CLOSED"];
const severities = [1, 2, 3];

export default function TicketFilters({ sites, value, onChange }: Props) {
  const update = (patch: Partial<TicketFiltersState>) => onChange({ ...value, ...patch });

  return (
    <div className="bg-white border border-slate-200 shadow-sm rounded-lg p-4 flex flex-col md:flex-row gap-3 md:items-end">
      <div className="flex-1">
        <label className="block text-xs font-semibold text-slate-600 mb-1">Search</label>
        <input
          className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
          placeholder="Search notes or status..."
          value={value.search}
          onChange={(e) => update({ search: e.target.value })}
        />
      </div>
      <div>
        <label className="block text-xs font-semibold text-slate-600 mb-1">Site</label>
        <select
          className="rounded-md border border-slate-200 px-3 py-2 text-sm"
          value={value.siteId}
          onChange={(e) => update({ siteId: e.target.value === "all" ? "all" : Number(e.target.value) })}
        >
          <option value="all">All sites</option>
          {sites.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-semibold text-slate-600 mb-1">Status</label>
        <select
          className="rounded-md border border-slate-200 px-3 py-2 text-sm"
          value={value.status}
          onChange={(e) => update({ status: e.target.value as any })}
        >
          <option value="all">All</option>
          {statuses.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-semibold text-slate-600 mb-1">Severity</label>
        <select
          className="rounded-md border border-slate-200 px-3 py-2 text-sm"
          value={value.severity}
          onChange={(e) => update({ severity: e.target.value === "all" ? "all" : Number(e.target.value) })}
        >
          <option value="all">All</option>
          {severities.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
